// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"9da8f0cb","341":"47ab32f5","453":"3fc02e0a","649":"39c8d776","717":"e3713b29"}[chunkId] + ".chunk.css";
};